module.exports = __webpack_public_path__ + "assets/img/bf.0d17a8ae.png";